import React from "react";
import { type Block } from "@/sections/SectionRenderer";

type VideoData = Block & {
  title?: string;
  url: string;
};

function getYouTubeId(url: string): string | null {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.slice(1);

    const v = u.searchParams.get("v");
    if (v) return v;

    const parts = u.pathname.split("/");
    const idx = parts.indexOf("embed");
    if (idx !== -1) {
      const candidate = parts[idx + 1];
      if (typeof candidate === "string" && candidate.length > 0) {
        return candidate;
      }
    }
  } catch {}
  return null;
}

export function VideoPlayer({
  url,
  title,
  className,
}: {
  url: string;
  title?: string;
  className?: string;
}) {
  const vid = getYouTubeId(url);
  if (!vid) return null;
  const embedSrc = `https://www.youtube-nocookie.com/embed/${vid}?rel=0`;

  return (
    <div className={`relative w-full overflow-hidden bg-black pb-[56.25%] ${className ?? ""}`}>
      <iframe
        className="absolute inset-0 h-full w-full"
        src={embedSrc}
        title={title ?? "YouTube video player"}
        style={{ border: 0 }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}

export function VideoEmbed({ data }: { data: VideoData }) {
  const { id, title, url } = data;
  return (
    <section id={id} className="relative bg-transparent">
      <div className="mx-auto px-6 lg:px-32 py-12 lg:py-20">
        <VideoPlayer url={url} title={title} className="rounded-2xl shadow-lg" />
      </div>
    </section>
  );
}